import { getSubscriberCursors } from "@features/builder/EditorPoc/helpers"
import SubscriberCursor from "@features/builder/EditorPoc/SubscriberCursor"
import {
  CursorRoomPayloadMembers,
  cursorObserver,
  getCursorRoomData,
} from "@features/builder/hooks/socketIOHooks"
import { SocketRoomPrefix } from "@features/builder/types"
import { Box } from "@mui/material"
import { useAtomValue } from "jotai"
import { loggedInUserAtom } from "@store/authAtoms"
import { useSyncExternalStore } from "react"

interface CursorOverlayProps {
  graphId: string
}

const CursorOverlay = (props: CursorOverlayProps) => {
  const user = useAtomValue(loggedInUserAtom)
  const roomName = `${SocketRoomPrefix.CURSOR}-${props.graphId}`
  const roomData = useSyncExternalStore<CursorRoomPayloadMembers | undefined>(
    (callback) => {
      const sub = cursorObserver.subscribe(() => callback())
      return () => {
        sub.unsubscribe()
      }
    },
    () => getCursorRoomData(roomName),
  )

  if (!roomData) return

  // filter out logged in user's own cursor
  const showSelf = import.meta.env.VITE_BUILD_SHOW_OWN_CURSOR == "true"
  const subscriberCursors = roomData
    ? getSubscriberCursors(roomData.payload, roomData.members).filter(
        ({ subscriber }) => showSelf || subscriber.email !== user?.email,
      )
    : []

  return (
    <Box
      style={{
        position: "fixed",
        width: "100%",
        height: "100%",
        zIndex: 4,
        pointerEvents: "none",
        top: 0,
        left: 0,
      }}
    >
      {subscriberCursors.map(({ subscriber, cursor }) => (
        <SubscriberCursor key={subscriber.sid} cursor={cursor} subscriber={subscriber} />
      ))}
    </Box>
  )
}

export default CursorOverlay
